import * as IDB from 'idb-keyval'

export default class IDBStore {
  constructor (db, name) {
    db = `${process.env.NODE_ENV || 'development'}-${db}`
    this.store = new IDB.Store(db, name)
  }
  get (key) {
    return IDB.get(key, this.store)
  }
  set (key, value) {
    return IDB.set(key, value, this.store)
  }
  del (key) {
    return IDB.del(key, this.store)
  }
  clear () {
    return IDB.clear(this.store)
  }
  keys () {
    return IDB.keys(this.store)
  }
}



// WEBPACK FOOTER //
// ../webmango-core/state/lib/IDBStore.js